import type { SceneElement } from '../domain/schemas';

export interface Pose {
  x: number;
  y: number;
  scale: number;
  rotation: number;
  alpha: number;
}

const TAU = Math.PI * 2;

/**
 * Pure, deterministic pose for an element at `time` seconds on a stage of the given
 * size. Keeping this free of Pixi makes the animation testable and resize-independent.
 */
export function poseAt(element: SceneElement, time: number, width: number, height: number): Pose {
  const unit = Math.min(width, height);
  const cx = element.x * width;
  const cy = element.y * height;
  const t = time + element.phase * 4;
  const radius = (element.size * unit) / 2;
  switch (element.motion) {
    case 'orbit': {
      const r = unit * 0.18;
      return { x: cx + Math.cos(t * 1.2) * r, y: cy + Math.sin(t * 1.2) * r, scale: radius, rotation: 0, alpha: 1 };
    }
    case 'pulse': {
      const s = 1 + 0.35 * Math.sin(t * TAU * 0.5);
      return { x: cx, y: cy, scale: radius * s, rotation: 0, alpha: 0.6 + (0.4 * (s - 0.65)) / 0.7 };
    }
    case 'bounce': {
      const h = Math.abs(Math.sin(t * 2.4)) * unit * 0.2;
      return { x: cx, y: cy - h, scale: radius, rotation: 0, alpha: 1 };
    }
    case 'spin':
      return { x: cx, y: cy, scale: radius, rotation: t * 1.5, alpha: 1 };
  }
}

export const hexToNumber = (hex: string): number => Number.parseInt(hex.slice(1), 16);
